export default "__VITE_ASSET__DE3SDa_$__"